<template>
  <section class="minimal-information-national">
    <main class="card p-2 shadow-none">
      <section class="formCampanha mt-2">
        <validation-observer ref="campanhaRules">
          <b-form>
            <b-row>
              <b-col
                lg="12"
                md="12"
                sm="12"
              >
                <b-form-group
                  label="Nome da Campanha*"
                  label-for="name-campanha"
                  class="mb-0"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="nameCampanha"
                    rules="required"
                  >
                    <b-form-input
                      id="name-campanha"
                      v-model="descricaoSelecionada"
                      v-mask="'X'.repeat(200)"
                      :state="
                        errors.length > 0 || form.errors.nameCampanha
                          ? false
                          : null
                      "
                      autocomplete="off"
                      placeholder="Dê o nome da campanha"
                    />
                    <small
                      v-if="errors[0]"
                      class="text-danger d-block"
                    >
                      Este campo é de preenchimento obrigatório.
                    </small>
                    <small
                      v-if="form.errors.nameCampanha"
                      class="text-danger"
                    >
                      {{ form.errors.nameCampanha }}
                    </small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="mt-1">
              <b-col
                lg="6"
                md="6"
                sm="12"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Vacina"
                  rules="required"
                >
                  <b-form-group
                    label="Vacina*"
                    label-for="vaccines"
                    :state="
                      errors.length > 0 || form.errors.vaccines ? false : null
                    "
                  >
                    <v-select
                      id="vaccines"
                      v-model="form.vacinas"
                      :options="formVacinas"
                      :close-on-select="false"
                      multiselect
                      multiple
                      label="nome_tecnico"
                      placeholder="Selecione uma ou mais"
                      :disabled="desabilitar"
                      @input="selectedVaccines"
                    >
                      <span slot="no-options">Nenhuma opção selecionável.</span>
                    </v-select>
                    <small
                      v-if="errors[0]"
                      class="text-danger d-block"
                    >
                      Este campo é de preenchimento obrigatório.
                    </small>
                    <small
                      v-if="form.errors.vacinas"
                      class="text-danger"
                    >
                      {{ form.errors.vacinas }}
                    </small>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                lg="3"
                md="6"
                sm="12"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Vacina"
                  rules="required"
                >
                  <b-form-group
                    label="Data de Início*"
                    label-for="inicio-input"
                  >
                    <b-input-group>
                      <b-form-input
                        id="inicio-input"
                        v-model="input.data_inicio"
                        v-mask="'##/##/####'"
                        class="form-control"
                        :state="errorOnDateInicio || errorOnDateTermino ? false : null"
                        placeholder="00/00/0000"
                        autocomplete="off"
                        @input="setInput($event, 'data_inicio')"
                      />
                      <b-input-group-append>
                        <b-form-datepicker
                          v-model="form.data_inicio"
                          class="form-control d-flex align-items-center"
                          locale="pt-BR"
                          button-only
                          right
                          :hide-header="true"
                          label-help="Selecione a data de início"
                          button-variant="custom-blue"
                          clearable
                          @input="setPicker($event, 'data_inicio')"
                        />
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col
                lg="3"
                md="6"
                sm="12"
              >
                <validation-provider
                  name="data_termino"
                  rules="required"
                >
                  <b-form-group
                    label="Data de Término*"
                    label-for="termino-input"
                  >
                    <b-input-group>
                      <b-form-input
                        id="termino-input"
                        v-model="input.data_termino"
                        v-mask="'##/##/####'"
                        class="form-control"
                        :state="errorOnDateInicio || errorOnDateTermino ? false : null"
                        placeholder="00/00/0000"
                        autocomplete="off"
                        @input="setInput($event, 'data_termino')"
                      />
                      <b-input-group-append>
                        <b-form-datepicker
                          v-model="form.data_termino"
                          class="form-control d-flex align-items-center"
                          locale="pt-BR"
                          button-only
                          right
                          :hide-header="true"
                          label-help="Selecione a data de término"
                          button-variant="custom-blue"
                          clearable
                          @input="setPicker($event, 'data_termino')"
                        />
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <tolerancia-input
                :value="form.tolerancia_dias_pos_termino"
                :exibir="exibirCampoTolerancia"
                @input="setToleranciaDiasPosTermino"
              />
            </b-row>
            <b-row>
              <b-col lg="12" md="12" sm="12" class="mt-2">
                <validation-provider
                    #default="{ errors }"
                    name="integracaoRnds"
                    rules="required"
                >
                  <integracao-rnds-input @setIntegracaoRnds="setIntegracaoRnds" />
                  <input type="hidden" name="integracaoRnds" :value="form.integracaoRnds">
                  <small v-if="errors[0]" class="text-danger d-block">
                    Este campo é de preenchimento obrigatório.
                  </small>
                </validation-provider>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
        <hr class="mt-2">
      </section>
    </main>
  </section>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
  BBadge,
  BAlert,
  BInputGroup,
  BFormDatepicker,
  BInputGroupAppend,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import vSelect from 'vue-select'
import moment from 'moment'
import {
  CampanhaNacionalGetState,
  CampanhaNacionalGetFormVacinas,
  CampanhaNacionalSetVacinasSelecionada,
  CampanhaNacionalGetVacinasSelecionada,
  CampanhaNacionalSetDescricao,
  CampanhaNacionalGetDescricao,
  CampanhaNacionalSetDataInicioSelecionado,
  CampanhaNacionalSetDataTerminoSelecionado,
  CampanhaNacionalGetGruposSelecionado,
  CampanhaNacionalResetVacinas,
  CampanhaNacionalSetIntegracaoRndsSelecionado,
  CampanhaNacionalSetToleranciaDiasPosTermino,
  podeVisualizarTolerancia,
} from '@/views/custom-pages/campanha-nacional/Helpers/campanhaNacionalHelpers.js'
import IntegracaoRndsInput from "@/views/components/custom/Inputs/IntegracaoRndsInput.vue";
import ToleranciaInput from "@/views/components/custom/Inputs/ToleranciaInput.vue";

export default {
  components: {
    IntegracaoRndsInput,
    ToleranciaInput,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BBadge,
    BAlert,
    BInputGroup,
    BFormDatepicker,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },

  props: {
    removedVaccina: {
      required: false,
      type: Number,
    },
  },

  data() {
    return {
      required,
      desabilitar: false,
      form: {
        integracaoRnds: null,
        nameCampanha: null,
        vacinas: [],
        data_inicio: null,
        data_termino: null,
        tolerancia_dias_pos_termino: null,
        errors: {
          nameCampanha: null,
          vacinas: null,
        },
      },
      input: {
        data_inicio: null,
        data_termino: null,
      },
      vaccines: [],
      errorOnDateInicio: false,
      errorOnDateTermino: false,
      mensagemCampo:
        'Não é possível realizar esta ação pois já existe um ou mais grupo(s) vinculado a(s) vacina(s)',
    }
  },

  computed: {
    campanhaNacionalState() {
      return CampanhaNacionalGetState()
    },
    formVacinas() {
      return CampanhaNacionalGetFormVacinas()
    },
    vacinaSelecionada() {
      return CampanhaNacionalGetVacinasSelecionada()
    },
    descricaoSelecionada: {
      get: () => CampanhaNacionalGetDescricao(),
      set: value => CampanhaNacionalSetDescricao(value),
    },
    exibirCampoTolerancia() {
      return podeVisualizarTolerancia()
    },
  },

  watch: {
    removedVaccina(id_vacina) {
      this.form.vaccines = this.form.vaccines.filter(
        vaccine => vaccine.id_vacina !== id_vacina,
      )
      this.emitEventSelectedVaccines()
    },
    '$store.state.campanhaNacionalState.watchers.grupos': {
      immediate: false,
      handler() {
        const grupos = CampanhaNacionalGetGruposSelecionado()
        this.desabilitar = Object.values(grupos).some(
          item => Object.keys(item).length !== 0 && item.constructor === Object,
        )
      },
    },
  },

  methods: {
    validateForm() {},

    selectedVaccines() {
      if (this.form.vacinas.length) {
        CampanhaNacionalSetVacinasSelecionada(this.form.vacinas)
      } else {
        CampanhaNacionalResetVacinas()
      }
    },

    setDataInicio(dataDB) {
      const data = moment(dataDB, 'YYYY-MM-DD')

      this.form.data_inicio = dataDB
      this.input.data_inicio = data.format('DD/MM/YYYY')
      CampanhaNacionalSetDataInicioSelecionado(dataDB)
    },

    setDataTermino(dataDB) {
      const data = moment(dataDB, 'YYYY-MM-DD')

      this.form.data_termino = dataDB
      this.input.data_termino = data.format('DD/MM/YYYY')

      CampanhaNacionalSetDataTerminoSelecionado(dataDB)
    },

    setPicker(data, campo) {
      if (campo == 'data_inicio') {
        this.setDataInicio(data)
        return
      }
      this.setDataTermino(data)
    },

    setInput(data, campo) {
      if (data.length == 10) {
        const dataDB = moment(this.input[campo], 'DD/MM/YYYY').format(
          'YYYY-MM-DD',
        )

        if (campo == 'data_inicio') {
          this.setDataInicio(dataDB)
          return
        }
        this.setDataTermino(dataDB)
      }
    },
    setIntegracaoRnds(value) {
      this.form.integracaoRnds = value;
      CampanhaNacionalSetIntegracaoRndsSelecionado(this.form.integracaoRnds)
    },
    setToleranciaDiasPosTermino(value) {
      this.form.tolerancia_dias_pos_termino = value;
      CampanhaNacionalSetToleranciaDiasPosTermino(value);
    }
  },
}
</script>

<style>
.minimal-information-national .dropdown-menu {
  z-index: 99999999;
}
</style>
